

import axios from "axios";
import { store } from "../redux/store";
import { logout } from "../redux/authSlice";
import {API_BASE_URL} from "../../../constants/constants"

const axiosInstance = axios.create({
	baseURL: API_BASE_URL, // Replace with your API base URL
	headers: {
		"Content-Type": "application/json",
	},
}); 

axiosInstance.interceptors.request.use(
	(config) => {
		const accessToken = store.getState().auth.accessToken;
		if (accessToken && config.headers) {
			config.headers["Authorization"] = `Bearer ${accessToken}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			console.error("Unauthorized! Redirecting to login...");
			store.dispatch(logout());
			window.location.href = "/login";
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;
